/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-27 10:00:30
 */
import {Outlet} from "react-router-dom";
import {Layout} from "antd";
import {setAuthButtons} from "@/redux/modules/auth/action";
import {updateCollapse} from "@/redux/modules/menu/action";
import {connect} from "react-redux";
import LayoutMenu from "./components/Menu";
import LayoutHeader from "./components/Header";
import LayoutTabs from "./components/Tabs";
import LayoutFooter from "./components/Footer";
import CustomerServiceFloating from "./components/CustomerServiceFloating";
import "./index.less";

const LayoutIndex = (props: any) => {
	const {Sider, Content} = Layout;

	return (
		// 这里不用 Layout 组件原因是切换页面时样式会先错乱然后在正常显示，造成页面闪屏效果
		<section className="container">
			<Sider trigger={null} collapsed={false} width="256px" theme="dark">
				<LayoutMenu></LayoutMenu>
			</Sider>
			<Layout>
				<LayoutHeader></LayoutHeader>
				<LayoutTabs></LayoutTabs>
				<Content>
					<Outlet></Outlet>
				</Content>
				{/* <CustomerServiceFloating/> */}
				<LayoutFooter></LayoutFooter>
			</Layout>
		</section>
	);
};

const mapStateToProps = (state: any) => state.menu;
const mapDispatchToProps = {setAuthButtons, updateCollapse};
export default connect(mapStateToProps, mapDispatchToProps)(LayoutIndex);
